import { LOGIN_DETAILS } from '../actions/types'

const initialState = {}

const loginDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_DETAILS:
      return action.payload
    default:
      return state
  }
}

export default loginDetailsReducer
